import { Progress } from 'antd';
import { useEffect, useState } from 'react';

import FileLogo from '../assets/FileLogo.jsx';
import FileLogoDocChat from '../assets/FileLogoDocChat.jsx';
import { DOC_CHAT, RE_ANALYSIS } from '../Constants/commonConstants.js';

let timerId = null;

function Loader({ time, type, product }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    for (let i = 1; i <= 2; i++) {
      clearTimeout(timerId);
      timerId = setTimeout(() => {
        setProgress(i * 50);
      }, i * +time);
    }

    return () => {
      clearTimeout(timerId);
    };
  }, []);

  return (
    <section className={`${type === RE_ANALYSIS && 'blur-screen'} loader-section`}>
      <div className='loader-content'>
        {product === DOC_CHAT ? <FileLogoDocChat /> : <FileLogo />}

        <Progress
          percent={progress}
          showInfo={false}
          size='small'
          strokeColor={{ '0%': '#007fff', '100%': '#007fff' }}
        />
        {type === RE_ANALYSIS && <p className='re-analysis-logo'>Re-Analysing...</p>}
      </div>
    </section>
  );
}

export default Loader;
